// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/sass/colors/megna.scss
// module id = 591
// module chunks = 376